(() => {
  const MATERIALS = {
    oak: 'repeating-linear-gradient(92deg,#d9a66a 0 8px,#c99156 9px 12px,#e5ba7e 13px 20px,#bc844c 21px 24px)',
    maple: 'repeating-linear-gradient(90deg,#ead2a9 0 10px,#f4e0bd 11px 17px,#d8bd8e 18px 22px)',
    walnut: 'repeating-linear-gradient(90deg,#60432f 0 9px,#76533a 10px 15px,#4c3325 16px 21px)',
    black: 'linear-gradient(90deg,#1a1a1a 0%,#3f3f3f 35%,#171717 70%,#292929 100%)',
    white: 'linear-gradient(90deg,#e5e5df 0%,#ffffff 34%,#deded9 70%,#f6f6f1 100%)'
  };

  const MAT_PADDING = { none: 0, standard: 8.5, oversized: 16 };

  function init(root) {
    if (root.dataset.llffReady === 'true') return;
    root.dataset.llffReady = 'true';

    const stage = root.querySelector('[data-llff-stage]');
    const frame = root.querySelector('[data-llff-frame]');
    const materialA = root.querySelector('[data-llff-material-a]');
    const materialB = root.querySelector('[data-llff-material-b]');
    const mat = root.querySelector('[data-llff-mat]');
    const photoWindow = root.querySelector('[data-llff-photo-window]');
    const photo = root.querySelector('[data-llff-photo]');
    const empty = root.querySelector('[data-llff-empty]');
    const fileInput = root.querySelector('[data-llff-file-input]');
    const uploadButton = root.querySelector('[data-llff-upload-button]');
    const uploadLabel = root.querySelector('[data-llff-upload-label]');
    const tools = root.querySelector('[data-llff-photo-tools]');
    const sizeReadout = root.querySelector('[data-llff-size-readout]');
    const styleReadout = root.querySelector('[data-llff-style-readout]');
    const acrylic = root.querySelector('[data-llff-acrylic]');
    const rails = Array.from(root.querySelectorAll('.llff__rail'));

    const state = {
      width: 8,
      height: 10,
      style: 'oak',
      mat: 'none',
      zoom: 1,
      posX: 50,
      posY: 50,
      materialFront: 'a',
      dragging: false,
      dragStartX: 0,
      dragStartY: 0,
      startPosX: 50,
      startPosY: 50
    };

    materialA.style.background = MATERIALS.oak;
    materialB.style.background = MATERIALS.oak;
    frame.style.setProperty('--frame-material', MATERIALS.oak);
    rails.forEach((rail) => { rail.style.background = MATERIALS.oak; });

    function updateFrameSize() {
      const stageBox = stage.getBoundingClientRect();
      const ratio = state.width / state.height;
      const maxW = Math.max(210, stageBox.width * 0.72);
      const maxH = Math.max(260, stageBox.height * 0.78);
      let w = maxH * ratio;
      let h = maxH;
      if (w > maxW) {
        w = maxW;
        h = w / ratio;
      }
      const physicalRailRatio = 0.87 / Math.max(state.width, state.height);
      const rail = Math.max(15, Math.min(32, Math.min(w, h) * Math.max(0.045, physicalRailRatio)));
      frame.style.setProperty('--frame-w', `${Math.round(w)}px`);
      frame.style.setProperty('--frame-h', `${Math.round(h)}px`);
      frame.style.setProperty('--rail', `${rail.toFixed(1)}px`);
      sizeReadout.textContent = `${state.width} × ${state.height}`;
    }

    function setMaterial(style) {
      if (!MATERIALS[style] || style === state.style) return;
      const front = state.materialFront === 'a' ? materialA : materialB;
      const back = state.materialFront === 'a' ? materialB : materialA;
      back.style.background = MATERIALS[style];
      frame.style.setProperty('--frame-material', MATERIALS[style]);
      rails.forEach((rail) => { rail.style.background = MATERIALS[style]; });
      back.style.opacity = '1';
      front.style.opacity = '0';
      state.materialFront = state.materialFront === 'a' ? 'b' : 'a';
      state.style = style;
      styleReadout.textContent = style.charAt(0).toUpperCase() + style.slice(1);
      window.setTimeout(() => {
        const hidden = state.materialFront === 'a' ? materialB : materialA;
        hidden.style.opacity = '0';
      }, 240);
    }

    function updatePhotoTransform() {
      photo.style.objectPosition = `${state.posX}% ${state.posY}%`;
      photo.style.transform = `scale(${state.zoom})`;
    }

    function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

    root.querySelectorAll('[data-width][data-height]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-width][data-height]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        state.width = Number(button.dataset.width) || 8;
        state.height = Number(button.dataset.height) || 10;
        requestAnimationFrame(updateFrameSize);
      });
    });

    root.querySelectorAll('[data-style]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-style]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        setMaterial(button.dataset.style);
      });
    });

    root.querySelectorAll('[data-mat]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-mat]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        const next = button.dataset.mat || 'none';
        state.mat = next;
        mat.style.padding = `${MAT_PADDING[next] || 0}%`;
        mat.classList.toggle('is-matted', next !== 'none');
      });
    });

    root.querySelector('[data-llff-acrylic-toggle]').addEventListener('change', (event) => {
      acrylic.classList.toggle('is-on', event.target.checked);
    });

    root.querySelector('[data-llff-bw]').addEventListener('change', (event) => {
      photo.style.filter = event.target.checked ? 'grayscale(1)' : 'none';
    });

    uploadButton.addEventListener('click', () => fileInput.click());
    empty.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) return;
      const url = URL.createObjectURL(file);
      if (photo.dataset.objectUrl) URL.revokeObjectURL(photo.dataset.objectUrl);
      photo.dataset.objectUrl = url;
      photo.src = url;
      photo.onload = () => {
        state.zoom = 1;
        state.posX = 50;
        state.posY = 50;
        updatePhotoTransform();
        photo.classList.add('is-loaded');
        empty.hidden = true;
        tools.hidden = false;
        uploadLabel.textContent = 'Change image';
      };
    });

    root.querySelector('[data-llff-zoom-in]').addEventListener('click', () => {
      state.zoom = clamp(state.zoom + 0.12, 1, 3);
      updatePhotoTransform();
    });
    root.querySelector('[data-llff-zoom-out]').addEventListener('click', () => {
      state.zoom = clamp(state.zoom - 0.12, 1, 3);
      updatePhotoTransform();
    });
    root.querySelector('[data-llff-reset-photo]').addEventListener('click', () => {
      state.zoom = 1;
      state.posX = 50;
      state.posY = 50;
      updatePhotoTransform();
    });

    photoWindow.addEventListener('pointerdown', (event) => {
      if (!photo.classList.contains('is-loaded')) return;
      state.dragging = true;
      state.dragStartX = event.clientX;
      state.dragStartY = event.clientY;
      state.startPosX = state.posX;
      state.startPosY = state.posY;
      photoWindow.setPointerCapture(event.pointerId);
    });
    photoWindow.addEventListener('pointermove', (event) => {
      if (!state.dragging) return;
      const rect = photoWindow.getBoundingClientRect();
      const dx = ((event.clientX - state.dragStartX) / Math.max(1, rect.width)) * 100;
      const dy = ((event.clientY - state.dragStartY) / Math.max(1, rect.height)) * 100;
      state.posX = clamp(state.startPosX - dx / Math.max(1, state.zoom - 0.15), 0, 100);
      state.posY = clamp(state.startPosY - dy / Math.max(1, state.zoom - 0.15), 0, 100);
      updatePhotoTransform();
    });
    const stopDrag = () => { state.dragging = false; };
    photoWindow.addEventListener('pointerup', stopDrag);
    photoWindow.addEventListener('pointercancel', stopDrag);

    photoWindow.addEventListener('wheel', (event) => {
      if (!photo.classList.contains('is-loaded')) return;
      event.preventDefault();
      state.zoom = clamp(state.zoom + (event.deltaY < 0 ? 0.08 : -0.08), 1, 3);
      updatePhotoTransform();
    }, { passive: false });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateFrameSize, 80);
    });

    requestAnimationFrame(updateFrameSize);
  }

  function boot() {
    document.querySelectorAll('[data-ll-frame-configurator]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
